/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useMemo } from "react";
import FinalCTA from "@/HomeComponents/FinalCTA";
import Hero from "@/HomeComponents/Hero";
import HowItWorks from "@/HomeComponents/HowItWorks";
import RealConnection from "@/HomeComponents/RealConnection";
import WhyAskLocal from "@/HomeComponents/WhyAskLocal";
import Blog from "@/HomeComponents/Blog";
import Testimonial from "@/HomeComponents/Testimonial";
import Navbar from "@/shared/Navbar";
import { usePages } from "@/hooks/usePages"; // ✅ dynamic how-to-hub fetch hook
import ProblemBlock from "@/HomeComponents/ProblemBlock";
// import ReviewsCarousel from "@/HomeComponents/googlereview";

export default function HomePage() {
  // ✅ Fetch all How-To-Hub pages dynamically
  const { data: pages, loading } = usePages();

  // ✅ Merge static + dynamic dropdown items
  const howToHubDropdown = useMemo(() => {
    const staticPages = [
      {
        label: "Property Intelligence Report",
        href: "/how-to-hub/property-intelligence-report",
      },
      { label: "Mortgage Guide", href: "/how-to-hub/mortgage-guide" },
    ];

    const dynamicPages =
      pages?.map((p: any) => ({
        label: p.title || "Untitled",
        href: `/how-to-hub/${p.slug}`,
      })) || [];

    // Merge dynamic first, then static
    return [
      ...(dynamicPages.length
        ? dynamicPages
        : loading
        ? [{ label: "Loading...", href: "#" }]
        : [{ label: "No Pages Found", href: "#" }]),
      ...staticPages,
    ];
  }, [pages, loading]);

  return (
    <div className="">
      {/* 🔹 Dynamic Navbar */}
      <Navbar
        defaultLogo="/logo/color-full-logo.png"
        scrolledLogo="/logo/color-full-logo.png"
        labelColor="#000000"
        labelHoverColor="#EB9C2C"
        buttonBg="#EB9C2C"
        buttonTextColor="#FFFFFF"
        ctaText="Looking to Buy/Sell?"
        ctaLink="/buy-sell"
        navItems={[
          { label: "Home", href: "/" },
 {
              label: "Search for Homes",
              href: "https://www.asklocalhomes.com/",
            },
          {
            label: "Property Reports",
            href: "/how-to-hub/property-intelligence-report",
          },
          {
            label: "How-To-Hub",
            dropdown: howToHubDropdown, //  merged dynamic + static
          },
          { label: "Log In", href: "https://portal.asklocal.com/" },
        ]}
      />

      {/* 🔹 Page Sections */}
      <Hero />
      {/* <ReviewsCarousel/> */}
      <ProblemBlock />
      <RealConnection />
      <HowItWorks />
      <WhyAskLocal />
      <Testimonial />
      <Blog />
      <FinalCTA />
    </div>
  );
}
